export default {

  levels: (state) => {
    return state.levels;
  },
  levelOptions: (state) => {
    const levelOptions = [];
    state.levels.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        icon: item.iconPath,
      };
      levelOptions.push(pushItem);
    }
    return levelOptions;
  },

  labels: (state) => {
    return state.labels;
  },
  labelOptions: (state) => {
    const labelOptions = [];
    state.labels.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
        icon: item.iconPath,
      };
      labelOptions.push(pushItem);
    }
    return labelOptions;
  },


  countryOptions: (state) => {
    const countryOptions = [];
    state.countries.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      countryOptions.push(pushItem);
    }
    return countryOptions;
  },

  provinces: (state) => {
    return state.provinces;
  },
  provinceOptions: (state) => {
    const provinceOptions = [];
    state.provinces.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      provinceOptions.push(pushItem);
    }
    return provinceOptions;
  },

  cities: (state) => {
    return state.cities;
  },
  citiesOptions: (state) => {
    const citiesOptions = [];
    state.cities.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      citiesOptions.push(pushItem);
    }
    return citiesOptions;
  },

  regions: (state) => {
    return state.regions;
  },
  regionOptions: (state) => {
    const regionOptions = [];
    state.regions.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      regionOptions.push(pushItem);
    }
    return regionOptions;
  },

  banks: (state) => {
    return state.banks;
  },
  bankOptions: (state) => {
    const bankOptions = [];
    state.banks.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      bankOptions.push(pushItem);
    }
    return bankOptions;
  },

  vendorCategory: (state) => {
    return state.vendorCategory;
  },
  vendorCategoryOptions: (state) => {
    const vendorCategoryOptions = [];
    state.vendorCategory.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      vendorCategoryOptions.push(pushItem);
    }
    return vendorCategoryOptions;
  },

  vendor: (state) => {
    return state.vendor;
  },
  vendorCatIdOptions: (state) => {
    const vendorCatIdOptions = [];
    state.vendor.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      vendorCatIdOptions.push(pushItem);
    }
    return vendorCatIdOptions;
  },

  vendors: (state) => {
    return state.vendors;
  },
  vendorsOptions: (state) => {
    const vendorsOptions = [];
    state.vendors.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.title,
      };
      vendorsOptions.push(pushItem);
    }
    return vendorsOptions;
  },

  customerOptions: (state) => {
    const customerOptions = [];
    state.customers.forEach(func);
    function func(item) {
      const pushItem = {
        value: item.id,
        text: item.fullName + ' (' + item.mobile + ')',
      };
      customerOptions.push(pushItem);
    }
    return customerOptions;
  },


  // Static Getters ---------------------------------------------------------------

  isMarreidOptions() {
    return [
      { value: false, text: "مجرد" },
      { value: true, text: "متاهل" },
    ];
  },

  genderOptions() {
    return [
      { value: 1, text: "آقا (مرد)" },
      { value: 2, text: "خانم (زن)" },
    ];
  },

  requestTypeOptions() {
    return [
      { value: 1, text: "قفسه جایزه" },
      { value: 2, text: "ارسال پیام" },
    ];
  },

  requestForOptions() {
    return [
      { value: 1, text: "مجموعه‌های داخل مرکز" },
      { value: 2, text: "مجموعه‌های خارج از مرکز" },
    ];
  },

 scoreTypeOptions() {
    return [
      { value: 1, text: "امتیازدهی ثابت" },
      { value: 2, text: "امتیازدهی متغیر" },
    ];
  },

 daysOptions() {
    return [
      { value: 1, text: "شنبه" },
      { value: 2, text: "یکشنبه" },
      { value: 3, text: "دوشنبه" },
      { value: 4, text: "سه‌شنبه" },
      { value: 5, text: "چهارشنبه" },
      { value: 6, text: "پنج‌شنبه" },
      { value: 7, text: "جمعه" },
    ];
  },

 typeOptions() {
    return [
      { value: 1, text: "روز هفته" },
      { value: 2, text: "ماه" },
    ];
  },

};
